export enum WELL_GUARDIAN_MODULES {
  WELL_HEALTH = 'WELL_HEALTH',
  INTERVENTIONS = 'INTERVENTIONS',
  DEROGATIONS = 'DEROGATIONS',
  SYNERGI_CASES = 'SYNERGI_CASES',
  KEY_LINKS = 'KEY_LINKS',
  ALERTS_SUBSCRIPTION = 'ALERTS_SUBSCRIPTION',
  // WELL HEALTH SUBMODULES
  WELL_SINGLE_OVERVIEW = 'WELL_SINGLE_OVERVIEW',
  WELL_SINGLE_SCHEMATIC = 'WELL_SINGLE_SCHEMATIC',
  WELL_REVIEWS = 'WELL_REVIEWS',
  WELL_SINGLE_CHARTS = 'WELL_SINGLE_CHARTS',
  WELL_ALERTS = 'WELL_ALERTS',
  WELL_BEHAVIOUR = 'WELL_BEHAVIOUR',
  WELL_DGS_HSE = 'WELL_DGS_HSE',
  WELL_RESOURCE = 'WELL_RESOURCE',
  // INTERVENTIONS SUBMODULES
  WIR_LIST = 'WIR_LIST',
  WIR_CREATION = 'WIR_CREATION',
}
